import { Directive } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';

@Directive({
    selector: '[hasBegEndWhitespace]',
    providers: [{ provide: NG_VALIDATORS, useExisting: HasBegEndWhitespaceDirective, multi: true }],
    standalone: true,
})
export class HasBegEndWhitespaceDirective implements Validator {
	validate(control: AbstractControl): ValidationErrors {
		if (control.value && control.value.length !== control.value.trim().length) {
			return { hasBegEndWhitespace: true };
		}

		return null;
	}
}
